import type { NotificationSystemContext } from './NotificationSystemContext';

export class CalcRouteProgress {
    private ctx: NotificationSystemContext | null = null;
    private calculateRouteStarted: boolean = false;
    private initialRoutesToCalculate: number | null = null;
    private functionOnEnd: any | null = null;

    setContext(ctx: NotificationSystemContext): this {
        this.ctx = ctx;
        if (ctx.countRoutesInCalculation > 0) {
            this.calculateRouteStarted = true;
        }
        if (ctx.pendingCalculationsCounters?.to_calculate) {
            if (
                this.initialRoutesToCalculate === null ||
                ctx.pendingCalculationsCounters.to_calculate > this.initialRoutesToCalculate
            ) {
                this.initialRoutesToCalculate = ctx.pendingCalculationsCounters.to_calculate;
            }
        } else if (
            this.initialRoutesToCalculate !== null &&
            ctx.countRoutesInCalculation > this.initialRoutesToCalculate
        ) {
            this.initialRoutesToCalculate = ctx.countRoutesInCalculation;
        }
        return this;
    }

    startCalculation(endFn: any): this {
        this.calculateRouteStarted = true;
        this.functionOnEnd = endFn;
        this.initialRoutesToCalculate = this.ctx?.countRoutesToCalculate ?? null;
        return this;
    }

    stopCalculation(): this {
        this.calculateRouteStarted = false;
        if (typeof this.functionOnEnd === 'function') {
            console.log('CalcRouteProgress.stopCalculation() calling functionOnEnd()');
            this.functionOnEnd();
        }
        this.functionOnEnd = null;
        return this;
    }

    isCalculationInProgress(): boolean {
        return this.calculateRouteStarted;
    }

    showCalcButton() {
        if (this.ctx === null) {
            return false;
        }
        console.log('showCalcButton ctx', this.ctx);
        return this.ctx.countRoutesToCalculate > 0 && !this.calculateRouteStarted;
    }

    showProgressBar() {
        if (this.ctx === null) {
            return false;
        }
        console.log('ctx.countRoutesInCalculation', this.ctx.countRoutesInCalculation);
        console.log('this.calculateRouteStarted', this.calculateRouteStarted);
        console.log('this.initialRoutesToCalculate', this.initialRoutesToCalculate);
        return (
            this.ctx.countRoutesInCalculation > 0 &&
            this.calculateRouteStarted &&
            this.initialRoutesToCalculate !== null
        );
    }

    getProgressPercent(): number {
        let progressPercent = 0;
        if (!this.calculateRouteStarted) {
            return progressPercent;
        }
        if (this.initialRoutesToCalculate === null) {
            return 0;
            // throw new Error(
            //     'initialRoutesToCalculate is not set. Please call setContext() before calling getProgressPercent()'
            // );
        }
        if (!this.ctx?.countRoutesInCalculation) {
            return progressPercent;
        }
        progressPercent =
            this.initialRoutesToCalculate > 0
                ? Math.floor(
                      ((this.initialRoutesToCalculate - this.ctx?.countRoutesInCalculation) * 100) /
                          this.initialRoutesToCalculate
                  )
                : 0;
        progressPercent = Math.min(100, progressPercent);
        progressPercent = Math.max(0, progressPercent);
        console.log(
            'CalcRouteProgress.getProgressPercent()',
            progressPercent,
            '%',
            this.ctx?.countRoutesInCalculation ?? null,
            this.initialRoutesToCalculate
        );
        return progressPercent;
    }
}
